import { createSelector } from '@reduxjs/toolkit';

import { ModelRule } from 'src/containers/ProjectDiagram/types/data';
import { isRuleValid } from 'src/containers/ProjectDiagram/utils/rules/isRuleValid';
import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { projectRuleModelSelector } from 'src/selectors/projectRuleModel';

export const projectRulesByIdSelector = (projectId: string) =>
  createSelector(
    diagramSnapshotSelector(projectId),
    (diagram) => diagram?.model.modelData.rulesById || {}
  );

export const prevProjectRulesByIdSelector = (projectId: string) =>
  createSelector(
    diagramSnapshotSelector(projectId),
    (diagram) => diagram?.model.modelData.draftData?.prevModelData.rulesById
  );

export const projectRuleSelector = (projectId: string, ruleId: string) =>
  createSelector(
    projectRulesByIdSelector(projectId),
    (rulesById): ModelRule | null => rulesById[ruleId] || null
  );

/**
 * @returns set of rule ids that are invalid
 */
export const projectInvalidRulesByIdSelector = (projectId: string) =>
  createSelector(
    projectRulesByIdSelector(projectId),
    projectRuleModelSelector(projectId),
    (rulesById, validModel) =>
      Object.fromEntries(
        Object.entries(rulesById).filter(
          ([_, rule]) => !isRuleValid(rule, validModel)
        )
      )
  );
